import { useState } from "react";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import BalanceRow from "@/components/admin/BalanceRow";

export default function UserCard({ user, onChange }) {
  const { user: me, setUser } = useAuth();
  const [name, setName] = useState(user.name);
  const [email, setEmail] = useState(user.email || "");
  const [phone, setPhone] = useState(user.phone || "");
  const [password, setPassword] = useState("");

  const call = async (fn, msg) => {
    try { await fn(); toast.success(msg); onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  const saveProfile = () => call(async () => {
    const r = await api.patch(`/admin/users/${user.id}`, { name, email, phone, ...(password ? { password } : {}) });
    if (user.id === me.id) setUser(r.data);
    setPassword("");
  }, "User updated");
  const del = () => window.confirm(`Delete ${user.username}?`) && call(() => api.delete(`/admin/users/${user.id}`), "User deleted");
  const addAcc = () => call(() => api.post(`/admin/users/${user.id}/accounts`, { type: "savings", name: "Savings", balance: 0 }), "Savings account added");
  const addCard = () => call(() => api.post(`/admin/users/${user.id}/cards`, { name: "Maderian Rewards Visa", balance: 0, credit_limit: 25000 }), "Card added");

  return (
    <div className="tile" data-testid={`admin-user-${user.username}`}>
      <div className="p-6 grid gap-6">
        <div className="flex flex-wrap justify-between gap-3 items-center">
          <div>
            <div className="font-display font-bold text-lg text-[var(--navy)]">{user.name}</div>
            <div className="text-xs text-slate-500">@{user.username} · <span className={user.role === "admin" ? "text-[var(--red)] font-semibold" : ""}>{user.role}</span> · {user.source === "online" ? "signed up online" : "added by admin"}{user.phone ? ` · ${user.phone}` : ""}</div>
          </div>
          {user.id !== me.id && <button onClick={del} className="text-slate-400 hover:text-[var(--red)] flex items-center gap-1 text-sm" data-testid={`admin-delete-user-${user.username}`}><Trash2 size={15} /> Delete</button>}
        </div>
        <div className="grid sm:grid-cols-5 gap-3">
          <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Display name" data-testid={`admin-edit-name-${user.username}`} />
          <Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid={`admin-edit-email-${user.username}`} />
          <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone" data-testid={`admin-edit-phone-${user.username}`} />
          <Input value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password (optional)" data-testid={`admin-edit-password-${user.username}`} />
          <Button onClick={saveProfile} className="rounded-full bg-[var(--blue)] hover:bg-[var(--navy)]" data-testid={`admin-save-user-${user.username}`}>Save profile</Button>
        </div>
        <div className="grid gap-2">
          <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Accounts & cards</div>
          {user.accounts.map((a) => <BalanceRow key={a.id} item={a} kind="accounts" onChange={onChange} />)}
          {user.cards.map((c) => <BalanceRow key={c.id} item={c} kind="cards" onChange={onChange} />)}
          <div className="flex gap-2 mt-2">
            <Button variant="outline" size="sm" onClick={addAcc} data-testid={`admin-add-account-${user.username}`}><Plus size={14} className="mr-1" /> Savings account</Button>
            <Button variant="outline" size="sm" onClick={addCard} data-testid={`admin-add-card-${user.username}`}><Plus size={14} className="mr-1" /> Credit card</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
